import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthContext'
import { ToastProvider } from '@/components/ui/toast'
import ProtectedRoute from '@/components/ProtectedRoute'
import Layout from '@/components/Layout'
import Login from '@/pages/Login'
import Placeholder from '@/pages/Placeholder'
import ContratoList from '@/pages/contrato/ContratoList'
import ContratoForm from '@/pages/contrato/ContratoForm'
import NfList from '@/pages/nf/NfList'
import NfForm from '@/pages/nf/NfForm'
import CadastroIndex from '@/pages/cadastro/CadastroIndex'
import CadastroResource from '@/pages/cadastro/CadastroResource'
import Parametros from '@/pages/cadastro/Parametros'

export default function App() {
  return (
    <ToastProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/contrato" element={<ContratoList />} />
            <Route path="/contrato/novo" element={<ContratoForm />} />
            <Route path="/contrato/:id" element={<ContratoForm />} />
            <Route path="/nf" element={<NfList />} />
            <Route path="/nf/novo" element={<NfForm />} />
            <Route path="/nf/:id" element={<NfForm />} />
            <Route path="/cadastro" element={<CadastroIndex />} />
            <Route path="/cadastro/parametros" element={<Parametros />} />
            <Route path="/cadastro/:resource" element={<CadastroResource />} />
          </Route>

          <Route path="/" element={<Navigate to="/contrato" replace />} />
          <Route path="*" element={<Navigate to="/contrato" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ToastProvider>
  )
}
